export default "__VITE_ASSET__B4F1j1L3__"